module.exports = __webpack_public_path__ + "img/home-pocket_en.9cecda8.jpg";